module.exports = __webpack_public_path__ + "static/media/alfa0logo.44891b7d.jpg";